import { CHAT_REACTION_LABELS, type ChatReaction } from "~shared/chatExperienceSurvey";
import { ChatReactionIcon } from "../components/PersistentChat/ChatReactionIcon";

export function ChatSurveyRating({ rating, reaction, skipped }: {
  rating: number | null; reaction?: ChatReaction | null; skipped?: boolean;
}) {
  if (skipped) return <span className="text-gray-500">Skipped</span>;
  if (reaction) return <span className="inline-flex items-center gap-1.5 font-medium">
    <ChatReactionIcon reaction={reaction} />{CHAT_REACTION_LABELS[reaction]}
  </span>;
  if (rating == null) return <span>—</span>;
  return <span className="inline-flex text-amber-500" aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((star) => <span key={star} aria-hidden="true">{star <= rating ? "★" : "☆"}</span>)}
  </span>;
}
